export const TouchScreenHelper = {
  isTouchScreen(): boolean {
    return !!('ontouchstart' in window || navigator.maxTouchPoints);
  },
};
